import { useState, useEffect } from 'react';
import { V2Empty } from '../V2Empty.jsx';

// Mirrors V2Summary.jsx — defensive string coercion (see PR #1078).
function asText(v) {
  if (v == null) return '';
  if (typeof v === 'string') return v;
  if (typeof v === 'number' || typeof v === 'boolean') return String(v);
  return '';
}

export function V2Decisions({ decisions, loading }) {
  const [expanded, setExpanded] = useState(null);
  // Reset when the decisions list is replaced (fetch completes, filter changes)
  // so a stale index can't point to the wrong row.
  useEffect(() => { setExpanded(null); }, [decisions]);
  if (loading) return <div className="v2-loading" data-testid="v2-decisions-loading">Loading…</div>;
  if (!decisions.length) return <V2Empty message="No decisions recorded for this conversation." />;
  return (
    <div className="v2-decisions" data-testid="v2-decisions">
      <div className="v2-approx-badge" title="Filtered by time overlap with this conversation — scope is approximate">approximate scope</div>
      {decisions.map((d, i) => {
        const p = d?.payload || d || {};
        const display = d?.display || {};
        // JOBE-0169: chip label comes from the server-projected
        // display.label (first sentence of rationale, capped at 60
        // runes). Rationale expansion below stays on the payload —
        // detail-pane reveals the full text, not just the first
        // sentence.
        const label = asText(display.label) || `Decision ${i + 1}`;
        const rationale = p.rationale || p.body || '';
        const isOpen = expanded === i;
        return (
          <div key={i} className="v2-decision-row" data-testid="v2-decision-row">
            <button
              type="button"
              className="v2-decision-label"
              onClick={() => setExpanded(isOpen ? null : i)}
            >
              {label}
            </button>
            {isOpen && rationale && (
              <div className="v2-decision-body">{rationale}</div>
            )}
          </div>
        );
      })}
    </div>
  );
}
